module.exports = __webpack_public_path__ + "img/no_photo.44239469.png";